export default "__VITE_ASSET__qrb3x_6o__"